import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ServiceModel extends BaseModel {
  @attr("datetime") createdAt;
  @attr("datetime") updatedAt;
  @attr("string") serviceName;
  @attr("string") serviceCode;
  @attr("string") description;
  @belongsTo("client") createdBy;
  @belongsTo("client") updatedBy;
  @belongsTo("service") service;
}
